import { EventBroker } from "@frontend/lib/utils/event-broker";

export const LAYOUT_ANIMATION_EVENTS = {
  INIT_SETTINGS_MODAL: 'INIT_SETTINGS_MODAL',
  FRAMES_UPDATED: 'FRAMES_UPDATED',
}

export const layoutAnimationEventBroker = new EventBroker();
